<template>
  <div>
    <vs-button style="border-radius: 5px; width: 100%" type="gradient" :size="size" @click="$emit('test-click')"
      :icon="icon" :color="color" id="button-with-loading-iadearizalist" class="vs-con-loading__container">{{ title
      }}</vs-button>
  </div>
</template>
<script>
export default {
  props: ["size", "title", "icon", "color"],
};
</script>